import React, { useState } from 'react';
import ReactTable from 'react-table';
import ReactLoading from 'react-loading';
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';

import DropDownBid from './DropDownBid';
import { getLastRefreshedTime } from './utils';

const LotBidsDetailModal = ({ bidTitle, data, confirmBidHandler, onClose }) => {
  const [confirmBidButtonLoading, setPlaceBidButtonLoading] = useState(false);

  const lastRefreshedTimed = getLastRefreshedTime();
  const headers = [
    {
      Header: 'Lot',
      accessor: null,
      sortable: false,
      maxWidth: 50,
      Cell: ({ original: { lotNumberWithExtension, isClosed } }) => (
        <span className={isClosed ? 'disabled-label' : ''}>{lotNumberWithExtension}</span>
      ),
    },
    {
      Header: 'Description',
      accessor: null,
      sortable: false,
      Cell: ({ original: { lotDescription, isClosed } }) => (
        <span className={isClosed ? 'disabled-label' : ''}>{lotDescription}</span>
      ),
    },
    {
      Header: 'Current',
      accessor: null,
      sortable: false,
      maxWidth: 100,
      Cell: ({ original: { currentBid, isClosed } }) => (
        <div className={isClosed ? 'disabled-label' : ''}>
          <div>${currentBid}</div>
        </div>
      )
    },
    {
      Header: 'New Bid',
      accessor: null,
      sortable: false,
      maxWidth: 120,
      style: { overflow: 'unset' },
      Cell: ({ original: { bidIncrements, lotRef, isClosed } }) => (isClosed ? (
        <span className="disabled-label">Lot Closed</span>
      ) : (
        <DropDownBid lotRef={lotRef} bidIncrements={bidIncrements} />
      ))
    }
  ];

  return (
    <Modal isOpen className="bid-history-modal" toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <h3>{bidTitle}</h3>
        <h5>{lastRefreshedTimed}</h5>
      </ModalHeader>
      <ModalBody>
        <ReactTable
          minRows={1}
          data={data}
          defaultPageSize={500}
          columns={headers}
          showPagination={false}
          style={{ width: '100%' }}
          className="-highlight"
        />
        <Row className="mt-4">
          <Col xs={12} sm={12} className="align-right bidConfirmSection">
            <Button
              color="primary"
              className="cursor-not-allowed confirmButton placeBidbutton"
              onClick={() => {
                setPlaceBidButtonLoading(true);
                confirmBidHandler();
              }}
              disabled={confirmBidButtonLoading}
            >
              <span className="d-flex justify-content-between align-items-center">
                Confirm
                {confirmBidButtonLoading && <ReactLoading className="loading-spinner m-0 ml-3" type="spin" height="auto" width={15} />}
              </span>
            </Button>
            <Button
              color="primary"
              outline
              className="mx-3 cursor-not-allowed confirmButton"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default LotBidsDetailModal;
